import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

const HomeSearchSchema = z.object({
  accountNotLinked: z.boolean().optional(),
});

export const Route = createFileRoute("/home")({
  validateSearch: (search: unknown) => {
    const result = HomeSearchSchema.safeParse(search);
    return result.success ? result.data : {};
  },
});
